


// 全ページ共通の処理
import page_common from './page/common';
// トップページ
import page_home from './page/home';


/* *******************************
* DOM読み込み完了
*/
$(function () {

    page_common();

    // 各ページ専用
    // page_home();

});





// WEBPACK FOOTER //
// ./js/app.js